import type { CustomBreakdown } from 'features/charts-v2/types'
import type { FilterOption } from 'features/filters/types'

/**
 * Derives custom field breakdowns from filter options.
 * Filter options must have model information included (via include_model: true).
 */
export function deriveCustomBreakdowns(
  filterOptions: FilterOption[],
): CustomBreakdown[] {
  const reverseModelMap: Record<string, CustomBreakdown['model']> = {
    ProductModel: 'product',
    SourceModel: 'source',
    PostModel: 'post',
    PostTextModel: 'post_text',
  }
  return filterOptions
    .filter((opt) => {
      const hasModel = 'model' in opt && !!opt.model
      const isSelectType =
        !('filter_type' in opt) || opt.filter_type === 'select'
      const isNotDisabled = !('disabled' in opt) || !opt.disabled
      return hasModel && isSelectType && isNotDisabled
    })
    .map((opt) => {
      const model = reverseModelMap[opt.model!]
      if (!model) return null
      return { field: opt.field, alias: opt.alias || opt.field, model }
    })
    .filter((item): item is CustomBreakdown => item !== null)
}
